// Shared decimal helpers for the money/mass math in @zebra/core.
// Not part of the public API surface (not re-exported from src/index.ts).
import { Decimal } from 'decimal.js';
/** Quantities (kg) are decimal strings at 3 dp per CLAUDE.md. */
export const QTY_DP = 3;
/** Moisture percent is a decimal string 0-100; we keep 2 dp of precision. */
export const PCT_DP = 2;
export function toDecimal(value) {
    return new Decimal(value.toString());
}
/** Quantize a quantity to the canonical 3 dp (half-up). Quantities are 3 dp EVERYWHERE
 * (CLAUDE.md); quantizing at function entry guarantees arithmetic and stored values can
 * never disagree about emptiness (Wave 2 gate 2026-07-07, costing ghost-value bug). */
export function quantizeQty(value) {
    return value.toDecimalPlaces(QTY_DP, Decimal.ROUND_HALF_UP);
}
export function formatQty(value) {
    return quantizeQty(value).toFixed(QTY_DP);
}
export function formatPct(value) {
    return value.toDecimalPlaces(PCT_DP, Decimal.ROUND_HALF_UP).toFixed(PCT_DP);
}
/**
 * Money rounds half-up to whole cents at every boundary (CLAUDE.md). Decimal's
 * ROUND_HALF_UP rounds ties away from zero, which is the standard "half up"
 * behaviour for the non-negative cent amounts this codebase deals in.
 */
export function roundCents(value) {
    return BigInt(value.toDecimalPlaces(0, Decimal.ROUND_HALF_UP).toFixed(0));
}
export function clampDecimal(value, min, max) {
    if (value.lt(min))
        return min;
    if (value.gt(max))
        return max;
    return value;
}
//# sourceMappingURL=decimal-utils.js.map